// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import Promise from 'bluebird';
import myw from 'myWorld/base/core';
import './datasource';

myw.MapquestDatasource = myw.Datasource.extend('MapquestDatasource', {
    statics: {
        layerDefFields: [
            {
                name: 'mapType',
                type: 'enumerator',
                enumerator: ['Map', 'Hybrid', 'Satellite', 'Dark', 'Light']
            }
        ],
        specFields: [{ name: 'license', type: 'string' }]
    },

    options: {
        license: '',
        libraryLoadTimeout: 1500,
        mapsPluginUrl: 'https://www.mapquestapi.com/sdk/leaflet/v2.2/mq-map.js',
        mapTypes: {
            Map: 'MQ.mapLayer',
            Hybrid: 'MQ.hybridLayer',
            Satellite: 'MQ.satelliteLayer',
            Dark: 'MQ.darkLayer',
            Light: 'MQ.lightLayer'
        }
    },

    /**
     * @class Datasource to provide visualisation of MapQuest layers </br>
     * @param  {Application} owner  The application
     * @constructs
     */
    initialize(database, options) {
        myw.Datasource.prototype.initialize.call(this, database, options);

        this.initialized = this._loadLibrary()
            .then(this._handleSuccess)
            .return(this);
    },

    /**
     * Loads the Mapquest Map leaflet plugin
     * @return {promise} Fulfilled when library has loaded successfully
     * @private
     */
    _loadLibrary() {
        const url = `${this.options.mapsPluginUrl}?key=${this.options.license}`;
        const self = this;
        const loadScriptRequest = Promise.resolve($.getScript(url))
            .timeout(this.options.libraryLoadTimeout)
            //ENH: notify of error? .catch(this._handleError) //fires event and passes rejection on
            .catch(
                e =>
                    new Promise((resolve, reject) => {
                        self.database.once('internetStatus-changed', e => {
                            //no reject handler in the line below because we don't want the
                            //initialized promise to be rejected - it's always waiting to be successfull
                            self._loadLibrary().then(resolve);
                        });
                    })
            );

        return loadScriptRequest;
    },

    /**
     * Instantiates a leaflet layer from a layer definition
     * @param  {layerDefinition} layerDef
     * @return {ILayer} Either a {@link GoogleOverlay} or a {@link GoogleBasemap} instance
     */
    createLayer(layerDef) {
        const layerFactoryName = this.options.mapTypes[layerDef.mapType];
        const layerFactory = myw.Util.evalAccessors(layerFactoryName);
        let layer;

        try {
            layer = layerFactory(layerDef.options);
        } catch (e) {
            console.log(`Error instantiating layer '${layerDef.name}'. Exception:`, e);
        }

        return layer;
    }
});

myw.datasourceTypes['mapquest'] = myw.MapquestDatasource;

export default myw.MapquestDatasource;
